const languages = [
  'en'
]

const specialJsonName = {
}

const langCodeToJsonName = (code) => specialJsonName[code] || code

const langCodeToCldrName = (code) => code

const ensureFinalFallback = codes => {
  const codeList = Array.isArray(codes) ? codes : [codes]
  return codeList.includes('en') ? codeList : codeList.concat(['en'])
}

module.exports = {
  languages,
  langCodeToJsonName,
  langCodeToCldrName,
  ensureFinalFallback
}
